export default __webpack_public_path__ + "6a1bce44ba6b2ee0a0549b7d6618d980.svg";